import styled from 'styled-components';
import { Dropdown as RawDropdown } from '@everlywell/leaves';

export const Dropdown = styled(RawDropdown)`
  select {
    text-transform: capitalize;
  }
`;
